import React, { useState, useEffect } from "react"
import makeRequest from "../../account/utils/make-request"

export default function BillingAddressInput({
  address,
  city,
  state,
  postalCode,
  country,
  onAddressChange,
  onCityChange,
  onStateChange,
  onPostalCodeChange,
  onCountryChange
}) {
  const [countryCodes, setCountryCodes] = useState([])

  const fetchCountries = async () => {
    const response = await makeRequest({
      url: "/billing/addresses/countries"
    })

    setCountryCodes(response)
  }

  useEffect(() => {
    fetchCountries()
  }, [])

  return (
    <div>
      <div className="row">
        <div className="col-sm-6">
          <label className="w-full font-semibold" htmlFor="cc-address-line1">
            Street Address
            <input
              id="cc-address-line1"
              spellCheck="false"
              autoCorrect="off"
              className="w-full kit-input p-3 mt-1"
              style={{ height: "42px" }}
              placeholder="123 Example St"
              type="text"
              value={address}
              onChange={event => onAddressChange(event.target.value)}
            />
          </label>
        </div>

        <div className="col-sm-6">
          <label className="w-full font-semibold" htmlFor="cc-city">
            City
            <input
              id="cc-city"
              spellCheck="false"
              autoCorrect="off"
              className="w-full kit-input p-3 mt-1"
              style={{ height: "42px" }}
              placeholder="Seattle"
              type="text"
              value={city}
              onChange={event => onCityChange(event.target.value)}
            />
          </label>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-sm-3">
          <label className="w-full font-semibold" htmlFor="cc-state">
            State/Province
            <input
              id="cc-state"
              spellCheck="false"
              autoCorrect="off"
              className="w-full kit-input p-3 mt-1"
              style={{ height: "42px" }}
              placeholder="WA"
              type="text"
              value={state}
              onChange={event => onStateChange(event.target.value)}
            />
          </label>
        </div>

        <div className="col-sm-3">
          <label className="w-full font-semibold" htmlFor="cc-zip">
            Postal Code
            <input
              id="cc-zip"
              type="text"
              spellCheck="false"
              autoCorrect="off"
              className="w-full kit-input p-3 mt-1"
              style={{ height: "42px" }}
              placeholder="12345"
              value={postalCode}
              onChange={event => onPostalCodeChange(event.target.value)}
            />
          </label>
        </div>

        <div className="col-sm-6">
          <label className="w-full font-semibold" htmlFor="cc-country">
            Country
            <select
              id="cc-country"
              name="country"
              autoComplete="address-level1"
              className="w-full kit-input p-3 mt-1"
              style={{ height: "42px" }}
              value={country}
              onChange={event => onCountryChange(event.target.value)}
            >
              <option key="select" value="">
                Select
              </option>
              {countryCodes.map(countryData => (
                <option key={countryData.value} value={countryData.value}>
                  {countryData.label}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>
    </div>
  )
}
